import { GlobalStyles as MuiGlobalStyle, useTheme } from "@mui/material";
import React, { FunctionComponent } from "react";

import { GlobalStyleProps } from "../types/styles";

export const GlobalStyle: FunctionComponent<{ minimal?: boolean }> = ({
  minimal,
}) => {
  const theme = useTheme();
  return (
    <MuiGlobalStyle
      styles={`
  html,
  body,
  #root {
    height: 100%;
    ${minimal ? "" : "overflow-x: hidden"};
  }

  body {
    background: ${theme.palette.background.default};
    margin: 0;
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`}
    />
  );
};
export default GlobalStyle;
